import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../../services/utils.service';

@Component({
    selector: 'app-footer',
    template: `
    <div class="div">
      <p class="footer-text" id="profileFont">
        For
        <a href="https://nuagedx.com/terms-and-conditions/" target="_blank">Terms & Conditions</a>
        and
        <a href="https://nuagedx.com/privacy-policy/" target="_blank">Privacy Policy</a>
        <br />
        please visit
        <a href="https://nuagedx.com/" target="_blank" style="color: #e53935">NuageDx</a>
      </p>
      <span class="version-info">
        {{ getDevVersion() }}
        <span class="version-sub">{{ getAppVersion() }}</span>
      </span>
    </div>
  `,
    styles: [
        `
      .div {
        background-color: #232323;
        color: white;
        position: fixed;
        margin: 0;
        bottom: 0;
        padding: 0 16px;
        left: 0;
        width: 100%;
        box-sizing: border-box;
        z-index: 2;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        min-height: 48px;
      }

      .footer-text {
        flex: 1;
        text-align: center;
        font-size: 13px;
        color: #e53935;
        margin: 4px 0;
      }

      .version-info {
        flex-shrink: 0;
        color: pink;
        text-align: right;
        white-space: nowrap;
      }

      .version-sub {
        display: block;
        font-size: 10px;
        color: #9c9c9c;
      }

      @media (max-width: 500px) {
        div {
          display: none;
        }
      }

      a:link,
      a:visited {
        color: #d73a31;
      }
    `
    ],
    standalone: false
})
export class FooterComponent {
  constructor(private u$: UtilsService) {}

  getAppVersion() {
    return environment.config.version;
  }

  getDevVersion() {
    return environment.config.devVersion;
  }
}
